module.exports = __webpack_public_path__ + "img/0Q3A3733_L_Black_MockedUp.d0ba3297.jpg";